import React from "react";
import MessageBubble from "./MessageBubble";
import WelcomeScreen from "./WelcomeScreen";

function isBotMessage(message) {
  return message.type === "SYSTEM" || message.sender === "bot" || message.type === "BOT";
}

function isUserMessage(message) {
  return message.type === "USER" || message.sender === "user";
}

function MessageList({
  sessionConversation,
  loader,
  isStreaming,
  chatEndRef,
  headerIcon,
  channelType,
  onSelectPrompt,
  onWidgetSubmit,
  feedbackWidget,
}) {
  const streamingBotId = isStreaming
    ? [...sessionConversation].reverse().find(isBotMessage)?.id
    : null;

  // Empty/welcome state: only bot/system messages so far, no user turn yet.
  const hasUserMessage = sessionConversation?.some(isUserMessage);
  const showWelcome =
    !hasUserMessage &&
    !loader &&
    !feedbackWidget &&
    sessionConversation?.length > 0 &&
    sessionConversation.every(isBotMessage);

  if (showWelcome) {
    const welcomeText = sessionConversation.find(isBotMessage)?.body || "";
    return (
      <div className="bot-main-container">
        <WelcomeScreen
          welcomeText={welcomeText}
          channelType={channelType}
          headerIcon={headerIcon}
          onSelectPrompt={onSelectPrompt}
        />
        <div ref={chatEndRef} />
      </div>
    );
  }

  return (
    <div className="bot-main-container">
      <div className="bot-thread">
        {sessionConversation?.map((message, index) => {
          const bot = isBotMessage(message);
          const prev = sessionConversation[index - 1];
          const grouped = prev && isBotMessage(prev) === bot;
          return (
            <MessageBubble
              key={message.id ?? index}
              message={message}
              grouped={grouped}
              isStreaming={isStreaming && message.id === streamingBotId}
              onSubmit={onWidgetSubmit}
            />
          );
        })}
        {feedbackWidget}
        {loader && (
          <div className="message-row message-enter">
            <div className="bot-block">
              <div className="typing-dots" aria-label="DIVA is typing">
                <span />
                <span />
                <span />
              </div>
            </div>
          </div>
        )}
        <div ref={chatEndRef} />
      </div>
    </div>
  );
}

export default MessageList;
